import React, { useState } from 'react';
import './EstiloAgregar.css'
import Select from 'react-select';
import ExoneracionModal from './ExoneracionModal';
import MediosDePago from './MediosDePago';
const AgregarProd = (props) => {
 
    const openModal = () => setModalIsOpen(true);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const closeModal = () => setModalIsOpen(false);

    const openModalMP = () => setModalIsOpenMP(true);
    const [modalIsOpenMP, setModalIsOpenMP] = useState(false);
    const closeModalMP = () => setModalIsOpenMP(false);
    return (
        <div className="product-area">
            <h2>Agregar Productos</h2>
            <div className="form-group-row">
                <div className="form-group product">
                    <label htmlFor="product">Producto</label>
                    <Select name="ProductoAgregar" id="ProductoAgregar"
                        value={props.ProductoSeleccionado}
                        onChange={props.handleChangeArts}
                        options={props.comboArts} />
                </div>
                <div className="form-group price">
                    <label htmlFor="price">Precio</label>
                    <input autoComplete='off' type="text" id="price" placeholder={props.Gestor.CodigoMoneda === "CRC" ? "₡0.00" : "$0.00"} />

                </div>
                <div className="form-group quantity">
                    <label htmlFor="quantity">Cantidad</label>
                    <input autoComplete='off' type="text" id="quantity" placeholder="0" />

                </div>
            </div> 
            <div className="form-group-row">
                <div className="form-group discount">
                    <label htmlFor="discount">Descuento</label>
                    <div className="checkbox-group">
                        <input autoComplete='off' type="text" id="discount" placeholder="0.00%" />
                        <label>
                            <input id="CkDescMonto" type="checkbox" /> x Monto
                        </label>
                    </div>
                </div>
                {props.Gestor.EsClienteExonerado ? (<div>
                    <button onClick={openModal}>Exoneración</button>
                    <ExoneracionModal
                        modalIsOpen={modalIsOpen}
                        closeModal={closeModal}
                        Gestor={props.Gestor}
                        Modificar={props.Modificar}
                    />
                </div>
                ) : null}
                <button onClick={() => props.AgregarDetalleLinea()} >Agregar</button>
                <div className="total">
                    <span>{'Total ' + (props.Gestor.CodigoMoneda === "CRC" ? "₡" : "$") + props.Gestor.TotalSap.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                </div>
                <div>
                <button onClick={openModalMP}>Medio Pago</button>
                <MediosDePago modalIsOpen={modalIsOpenMP}
                        closeModal={closeModalMP}
                        Gestor={props.Gestor}
                        Modificar={props.Modificar}
                        Total={'Total ' + (props.Gestor.CodigoMoneda === "CRC" ? "₡" : "$") + props.Gestor.TotalSap.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    />
                    </div>
            </div>
        </div>
    );
};

export default AgregarProd;